import { PropsWithChildren, FC } from 'react'
import { BulbOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import Link from '../Link'

type LearnMoreLinkPropsType = {
    linkTo: string
    followingText?: string
    name?: string
    placement?: string
}

const LearnMoreLink: FC<PropsWithChildren<LearnMoreLinkPropsType>> = (
    props: LearnMoreLinkPropsType,
) => {
    const {
        name = 'learn-more-link',
        placement = 'learn-more-link',
        followingText,
        linkTo,
    } = props

    return (
        <Box justifyContent="center">
            <BulbOutlined
                style={{
                    fontSize: '21px',
                    color: getColor('link'),
                    marginRight: '8px',
                }}
            />
            <Text>
                <Link
                    name={name}
                    data-target={name}
                    href={linkTo}
                    placement={placement}
                    target="_blank"
                >
                    Learn more{' '}
                </Link>
                {followingText}
            </Text>
        </Box>
    )
}

export default LearnMoreLink
